import React from "react";
import $ from "jquery";
import {AppConfig} from "../../AppConfig";
import UserCheckbox from "./UserCheckbox";
import LoadingImage from "../LoadingImage";
import axios from "axios";
import {globalSession} from "../../module/Session";


class UserCall extends React.Component {

    urlSearchParams = new URLSearchParams(window.location.search);

    constructor(props) {
        super(props);
        this.state = {serviceState: -1};
        this.getData();
    }

    getData() {
        axios.get(AppConfig.server + AppConfig.service.admin.callTypes + "/" + this.urlSearchParams.get("userId"), globalSession.getAuthToken())
            .then((res) => {
                const data = res.data;
                if (data.success) {
                    this.success(data["data"]);
                } else
                    this.fail();
            })
            .catch(e => {
                this.fail();
            })
    }

    success(data) {
        this.data = data;
        this.setState({
            serviceState: 1
        });
    }

    fail() {
        this.setState({
            serviceState: 2
        });
    }


    send() {
        const list = [];

        $("input:checkbox[name=departmentList]").each(function () {
            if ($(this).is(':checked')) {
                list.push(parseInt($(this).val()));
            }
        });

        const params = {
            userId: parseInt(this.urlSearchParams.get("userId")),
            idList: list
        };


        axios.put(AppConfig.server + AppConfig.service.admin.callTypes, params, globalSession.getAuthToken())
            .then((res) => {
                alert("Başarılı");
                window.location.reload();
            })
    }

    render() {
        if (this.state.serviceState === 1) {
            return (
                <div style={{padding: "15px"}}>


                    <h3><strong>Çağrı Ata</strong></h3>
                    <hr/>
                    <strong>{this.data["user"]["registryNo"] + " - " + this.data["user"]["name"] + " " + this.data["user"]["surname"]}</strong>


                    <button id={"saveButton"} style={{float: "right", marginTop: "-10px"}} type="button"
                            onClick={this.send.bind(this)} className="btn btn-primary">Kaydet
                    </button>
                    <hr style={{clear: "both"}}/>
                    {this.renderSelect()}
                </div>
            )
        } else if (this.state.serviceState === -1) {
            return (
                <LoadingImage/>
            )
        } else {
            return (
                <span>Tanımlı kullanıcı yoktur</span>
            )
        }
    }

    renderSelect() {
        const data = this.data["types"];
        return data.map((item, i) =>
            <UserCheckbox select={item["activeForUser"]} text={item["name"]}
                          value={item["id"]}/>);
    }

}


export default UserCall;